import { render, staticRenderFns } from "./Game2-3.vue?vue&type=template&id=4f692232&scoped=true&"
import script from "./Game2-3.vue?vue&type=script&lang=js&"
export * from "./Game2-3.vue?vue&type=script&lang=js&"
import style0 from "./Game2-3.vue?vue&type=style&index=0&id=4f692232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f692232",
  null
  
)

export default component.exports